<template>
  <favorite-action>
    <primary-action
      icon="sr-2 sr-v2-heart-filled"
      text="Favorite"
      v-on="$listeners"
      @click="onFavorite"
    />
  </favorite-action>
</template>

<script>
import PrimaryAction from '@/components/Navbar/PrimaryAction'
import FavoriteAction from '@/components/AthleteProfile/FavoriteAction'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        FavoriteAction,
        PrimaryAction,
    },
    computed: {
        ...mapGetters('athleteProfile', ['athlete']),
    },
    methods: {
        ...mapActions('athleteProfile', ['favorite']),
        async onFavorite() {
            await this.favorite();
            this.$emit('favorited', this.athlete)
        },
    },
}
</script>
